import { Link } from "react-router-dom";
import Reveal from "@/components/Reveal";
import { ArrowUpRight } from "lucide-react";
import { TREATS } from "@/data/site";

export default function Treats() {
    return (
        <section id="treats" data-testid="treats-section" className="py-16 md:py-24 lg:py-32 bg-[#FFFDF9]">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
                    <Reveal className="max-w-xl">
                        <p className="text-xs font-semibold uppercase tracking-[0.25em] text-[#C59B27]">The Bakery Case</p>
                        <h2 className="mt-3 font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#3D2318]">
                            Sweet Treats <span className="font-script font-medium text-[#C95B7D] text-4xl sm:text-5xl align-middle">&amp; More</span>
                        </h2>
                    </Reveal>
                    <Reveal delay={0.1}>
                        <p className="max-w-sm text-sm text-[#8C6A5D] leading-relaxed">
                            Every treat is homemade to order — tap a category to see flavors, options, and photos.
                        </p>
                    </Reveal>
                </div>

                <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
                    {TREATS.map((treat, i) => (
                        <Reveal key={treat.slug} delay={(i % 3) * 0.1} className={i === 0 ? "sm:col-span-2 lg:col-span-1" : ""}>
                            <Link
                                to={`/treats/${treat.slug}`}
                                data-testid={`treat-card-${treat.slug}`}
                                className="group block overflow-hidden rounded-[1.75rem] bg-white border border-[#F2E1E6] shadow-[0_12px_32px_rgba(61,35,24,0.07)] hover:shadow-[0_24px_60px_rgba(61,35,24,0.15)] hover:-translate-y-1.5 transition-[transform,box-shadow] duration-500"
                            >
                                <div className="relative h-56 overflow-hidden">
                                    <img
                                        src={treat.image}
                                        alt={treat.name}
                                        className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                                    />
                                    <span className="absolute left-4 top-4 rounded-full bg-[#FFFDF9]/90 backdrop-blur px-3.5 py-1.5 text-[10px] font-bold uppercase tracking-[0.15em] text-[#C59B27]">
                                        {treat.tag}
                                    </span>
                                </div>
                                <div className="flex items-start justify-between gap-4 p-6">
                                    <div>
                                        <h3 className="font-display text-xl font-bold text-[#3D2318] group-hover:text-[#C95B7D] transition-colors duration-300">
                                            {treat.name}
                                        </h3>
                                        <p className="mt-1.5 text-sm text-[#6B4A3E] leading-relaxed">{treat.description}</p>
                                    </div>
                                    <span className="mt-1 flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-[#F2E1E6] text-[#C95B7D] transition-[background-color,color,transform] duration-300 group-hover:bg-[#C95B7D] group-hover:text-white group-hover:rotate-45">
                                        <ArrowUpRight className="h-4 w-4" />
                                    </span>
                                </div>
                            </Link>
                        </Reveal>
                    ))}

                    <Reveal delay={0.2}>
                        <a
                            href="#order"
                            data-testid="treat-card-custom"
                            className="group flex h-full min-h-[280px] flex-col items-start justify-between rounded-[1.75rem] bg-[#3D2318] p-8 hover:-translate-y-1.5 transition-transform duration-500"
                        >
                            <p className="font-script text-3xl text-[#F8D7E3] leading-snug">
                                Something else<br />in mind?
                            </p>
                            <div>
                                <p className="text-sm text-[#FFFDF9]/70 leading-relaxed">
                                    Tell us your idea — if it's sweet, we'd love to try it.
                                </p>
                                <span className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-[#D4AF37] group-hover:text-[#F8D7E3] transition-colors duration-300">
                                    Ask About a Custom Order
                                    <ArrowUpRight className="h-4 w-4" />
                                </span>
                            </div>
                        </a>
                    </Reveal>
                </div>
            </div>
        </section>
    );
}
